import { useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { safeRequestIdleCallback } from '../../shared/lib/safe-request-idle-callback.js'

export default function ScrollIntoView({
  following = true,
  marginTop = '-150px',
}) {
  const scrollRef = useRef(null)

  useLayoutEffect(() => {
    function scroll() {
      scrollRef?.current?.scrollIntoView({
        // behavior: 'smooth', // Disabled to avoid layout shifting when users jump around the rundown
        block: 'start',
      })
    }

    if (following && scrollRef.current) {
      safeRequestIdleCallback(scroll, {
        timeout: 500,
      })
    }
  }, [following])

  return <div ref={scrollRef} style={{ marginTop }} className="absolute"></div>
}

ScrollIntoView.propTypes = {
  following: PropTypes.bool,
  marginTop: PropTypes.string,
}
